import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { getItemSession, removeItemSession } from "utils/session";
import { extractSystemId } from "utils/utils";
import { HEADER_STRINGS, RefreshKey, userProfileStrings } from "constants/constantStrings";
import ROUTES_PATH from "constants/pages.constant";

import DupontIconButton from "components/DupontIconButton";
import { DupontTooltip } from "components/DupontTooltip";
import StatusIndicator from "components/StatusIndicator";

import MembraneIcon from "assets/Header/desaliTec_Membrane.svg";
import LogoIcon from "assets/Logo/DuPontLogo_PaleGrey.svg";
import BackIcon from "assets/SvgIcon/BackIcon";
import UserProfileIcon from "assets/SvgIcon/Header/UserProfileIcon";

import LiveAlarmsNotifications from "./LiveAlarmsNotifications/index";
import UserInfo from "./UserInfo/UserInfo";
import SmartInsights from "./SmartInsights";

import "./index.scss";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { user, systems } = useSelector(state => state);
  const { isAdmin, isTier2 } = useSelector(state => state.user);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isInsideSystem, setIsInsideSystem] = useState(false);
  const [isBackBtnVisible, setIsBackBtnVisible] = useState(false);
  const [systemId, setSystemId] = useState("");
  const [systemLastUpdatedTime, setSystemLastUpdatedTime] = useState("");
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    const { pathname } = location;
    setSystemId(params.systemId);
    setIsInsideSystem(pathname.includes("/systems/"));
    setIsBackBtnVisible(pathname.includes("/settings/"));
    setLastUpdatedTime();
    if (isInsideSystem) {
      removeItemSession(RefreshKey.pageRefreshed);
    }
  }, [location]);

  useEffect(() => setLastUpdatedTime(), [systems]);

  const setLastUpdatedTime = () => {
    const systemID = extractSystemId();
    if (systemID) {
      const { systemsAsObj } = systems;
      let msg = "";
      if (systemsAsObj) {
        const systemData = systemsAsObj[systemID];
        msg = systemData?.lastActiveTime;
      }
      setSystemLastUpdatedTime(msg);
    }
  };

  const onUserDropdownClick = () => {
    objAppInsights.trackEvent("headerUserMenuOpen");
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };
  const navigateBack = () => {
    const isPageRefreshed = getItemSession(RefreshKey.pageRefreshed);
    isPageRefreshed ? navigate(ROUTES_PATH.HOME) : navigate(-1);
  };

  return (
    <AppBar position="fixed" className="Header app-main-header box_shadow_none">
      <Toolbar className="app-toolbar" disableGutters={false}>
        <>
          <div className="Header-spaceBetween d-flex">
            <Link to={ROUTES_PATH.HOME} state={{ reloadData: true }}>
              <div className="d-flex">
                <DupontTooltip title={HEADER_STRINGS.home} placement="bottom" type="primary">
                  <img src={LogoIcon} className="margin-right-auto dupont-logo" alt="logo" />
                </DupontTooltip>
                <DupontTooltip title={HEADER_STRINGS.home} placement="bottom" type="primary">
                  <div className="desalitec-logo">
                    <span className="desalitec-logo--main-heading">
                      {HEADER_STRINGS.desaliTec}
                      <sup className="desalitec-logo--secondary-heading desalitec-logo--trade-mark">&trade;</sup>
                    </span>
                    <span className="desalitec-logo--secondary-heading desalitec-logo--name-spacing">{HEADER_STRINGS.soarSmart}</span>
                    <img src={MembraneIcon} alt="membrane" className="desalitec-logo--icon" />
                  </div>
                </DupontTooltip>
              </div>
            </Link>
            {isBackBtnVisible && (
              <i className="header__back-btn">
                <DupontIconButton tooltip={userProfileStrings.headerBackBtnTooltip} onClick={navigateBack}>
                  <BackIcon type="primary" />
                </DupontIconButton>
              </i>
            )}

            {isInsideSystem && <StatusIndicator name="header" systemID={systemId} lastActiveTime={systemLastUpdatedTime} />}

            <ul className="rightContent">
              {user.isAuthorized && (
                <>
                {(isAdmin || isTier2) && (
                  <li className="pointer display_inline">
                    <SmartInsights />
                  </li>
                )}
                  <li className="pointer display_inline">
                    <LiveAlarmsNotifications />
                  </li>
                </>
              )}
              <li>
                <Dropdown className="margin-left-10 pointer" isOpen={isUserDropdownOpen} toggle={onUserDropdownClick}>
                  <DropdownToggle tag="span">
                    <DupontIconButton tooltip={userProfileStrings.userIconTooltip}>
                      <UserProfileIcon open={isUserDropdownOpen} />
                    </DupontIconButton>
                  </DropdownToggle>
                  {isUserDropdownOpen && (
                    <DropdownMenu right className="dropStyleMenu">
                      <UserInfo onUserDropdownClick={onUserDropdownClick} />
                    </DropdownMenu>
                  )}
                </Dropdown>
              </li>
            </ul>
          </div>
        </>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
